
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/[slug]",
      function () {
        return require("private-next-pages/program/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/[slug]"])
      });
    }
  